var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.25 31H56.875V22.25C56.875 10.175 47.075 0.375 35 0.375C22.925 0.375 13.125 10.175 13.125 22.25V31H8.75C3.9375 31 0 34.9375 0 39.75V83.5C0 88.3125 3.9375 92.25 8.75 92.25H61.25C66.0625 92.25 70 88.3125 70 83.5V39.75C70 34.9375 66.0625 31 61.25 31ZM35 70.375C30.1875 70.375 26.25 66.4375 26.25 61.625C26.25 56.8125 30.1875 52.875 35 52.875C39.8125 52.875 43.75 56.8125 43.75 61.625C43.75 66.4375 39.8125 70.375 35 70.375ZM21.875 22.25V31H48.125V22.25C48.125 14.9875 42.2625 9.125 35 9.125C27.7375 9.125 21.875 14.9875 21.875 22.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockComponent);
export default __webpack_public_path__ + "static/media/lockComponent.c88ab5479856b8649ca792623a41fc43.svg";
export { ForwardRef as ReactComponent };